module.exports = __webpack_public_path__ + "static/media/亲密爱人（梅艳芳）.bac9e820.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/music/亲密爱人（梅艳芳）.mp3
// module id = 491
// module chunks = 0